export class ApiUrls {
    public static urls = {
        admin: 'admin/login',
        domain_check: 'domain-check',
        auth_check: 'auth-check',
        login: 'login',
        logout: 'logout',
        home: {
            summery: 'summery'
        },
        role: {
            index: 'list',
            search: 'search',
            get_add: 'get-add',
            post: 'add',
            get_update: 'get-update',
            put: 'update',
            view: 'view'
        },
        permission: {
            index: 'list',
            search: 'search',
            post: 'add',
            get_update: 'get-update',
            put: 'update',
            status_update: 'status-update',
            delete: 'destroy',
        },
        users:'user_list',
        roles:'role_list',
        user: {
            index: 'list',
            get_add: 'get-add',
            post: 'add',
            get_update: 'get-update',
            update: 'update',
            update_status: 'update-status',
            view: 'view',
            get_unassigned_users: 'get-unassigned-users',
            assign_users: 'assign-users',
            unassigned_user: 'unassigned-user',
            child: {
                list: 'list'
            },
            asset: {
                list: 'list'
            },
        },
        device: {
            index: 'list',
            search: 'search',
            get_add: 'get-add',
            post: 'add',
            get_update: 'get-update',
            put: 'update',
            status_update: 'status-update',
            view: 'view',
            delete: 'destroy'
        },
        'device-events': {
            index: 'list',
            search: 'search',
            get_add: 'get-add',
            post: 'add',
            status_update: 'status-update',
            delete: 'destroy'
        },
        masking: {
            index: 'list',
            search: 'search',
            get_add: 'get-add',
            post: 'add',
            get_update: 'get-update',
            put: 'update',
            view: 'view',
            delete: 'destroy'
        },
        alerts: {
            index: 'list'
        },
        lists: 'lists',
        events: {
            index: 'list',
            search: 'search',
            get_add: 'get-add',
            post: 'add',
            get_update: 'get-update',
            put: 'update',
            status_update: 'status-update',
            view: 'view',
            delete: 'destroy'
        },
        asset: {
            index: 'list',
            events: 'events',
            get_add: 'get-add',
            post: 'add',
            'update-reporting-configuration': 'update-reporting-configuration',
            get_update: 'get-update',
            put: 'update',
            status_update: 'status-update',
            view: 'view',
            delete: 'destroy',
            device: {
                get_add: 'get-add',
                post: 'add',
                delete: 'destroy',
            },
            'odd-hours': {
                add:'add',
                get:'get',
            },
            trips: {
                list: 'list',
                show: 'show',
                attached: 'attached',
                show_summary: 'show_summary'
            }
        },
        poi: {
            index: 'list',
            search: 'search',
            post: 'add',
            get_update: 'get-update',
            upload_poi_kml_file: 'upload-file',
            put: 'update',
            status_update: 'status-update',
            delete: 'destroy',
        },
        zone: {
            index: 'list',
            get_assigned_zones: 'get-assigned-zones',
            search: 'search',
            post: 'add',
            get_update: 'get-update',
            get_view: 'view',
            put: 'update',
            status_update: 'status-update',
            delete: 'destroy',
        },
        routes: {
            index: 'list',
            search: 'search',
            post: 'add',
            view: 'view-route',
            poi: {
                post: 'add',
                status_update: 'status-update',
                delete: 'destroy',
            },
            get_update: 'get-update',
            put: 'update-route',
            status_update: 'status-update',
            delete: 'destroy',
        },
        'mapping-keys': {
            index: 'list',
            search: 'search',
            get_add: 'get-add',
            post: 'add',
            status_update: 'status-update',
            delete: 'destroy',
        },
        drivers: {
            index: 'list',
            search: 'search',
            post: 'add',
            put: 'update',
            view: 'info',
            delete: 'destroy',
            status_update: 'status-update',
        },
        'assets-group': {
            index: 'list',
            post: 'add',
            search: 'search',
            get_add: 'get-add',
            put: 'update',
            view: 'info',
            delete: 'destroy',
            status_active: 'status-active',
            status_inactive: 'status-inactive',
            assign_distributor: 'assign-user',
        },
        maintenance: {
            index: 'list',
            get_add: 'edit',
            post: 'add',
            update: 'update',
            close: 'close',
            delete: 'destroy',
        },
        'maintenance-work-jobs': {
            index: 'list',
            post: 'add',
            view: 'view',
            update: 'update',
            'update-time': 'update-time',
        },
        trips: {
            'trip-type-a': {
                post: 'add',
                edit: 'update',
            },
            'trip-type-b': {
                post: 'add',
            },
            'trip-type-c': {
                create: 'create',
                edit: 'update',
                view: 'view',
            },
            'trip-type-d': {
                post: 'add',
                show: 'show',
                print: 'print'
            },
            index: 'list',
            get_update: 'get-update',
            put: 'update',
            status_update: 'status-update',
            view: 'view',
            delete: 'destroy'
        },

        reports: {
            index: 'index',
            trip_summary: 'trip-summary',
            trip_detail: 'trip-detail',
            stop: 'stop',
            distance: 'distance',
            generate_fuel_filling_report: 'generate-fuel-filling-report',
            nr: 'nr',
            live: 'live',
            'get-vehicles': 'get-vehicles',
            'get-generators': 'get-generators',
            'get-zones': 'get-zones',
            'get-groups': 'get-groups',
            get_group_vehicles: 'get-group-vehicles',
            'generate-history-report': 'history',
            'generate-movement-report': 'movement',
            'generate-consolidated-report': 'consolidated',
            'generate-cumulative-consolidated-corporate': 'cumulative-consolidated-corporate',
            'generate-geofence-report': 'geofence',
            'generate-stop-over-report': 'stop-over',
            'generate-over-speed-report': 'over-speed',
            'generate-journey-report': 'journey',
            'generate-idle-report': 'idle',
            'generate-geofence-detail-report': 'geofence-detail',
            'generate-working-hours-report': 'working-hours',
            'generate-fleet-summary-report': 'fleet-summary',
            'generate-driving-quality-report': 'driving-quality',
            'generate-temperature-sensor-report': 'temperature-sensor',
            'van-wise-summary': 'van-wise-summary',
            'branch-wise-summary': 'branch-wise-summary',
            'trip-wise': 'trip-wise',
            user: 'user',
            asset: 'asset',
            out_vehicle: 'out-vehicles',
            not_out_vehicle: 'not-out-vehicles',
            gate_out: 'gate-out',
            gate_in: 'gate-in',
            field_time: 'field-time',
            moving_in_fence: 'moving-in-fence',
            moving_out_fence: 'moving-out-fence',
            off_work_time: 'off-work-time',
            total_trips: 'total-trips',
        },
        fuel_fillings: {
            index: 'list',
            search: 'search',
            get_add: 'get-add',
            post: 'add',
            get_update: 'get-update',
            put: 'update',
            status_update: 'status-update',
            view: 'view',
            delete: 'destroy',
        },
        tracker: {
            index: 'list',
            get: 'info',
            tree: 'tree',
            history: 'show-history',
            follow: 'start-follow',
            details: 'listEvent',
            vehicle_status: 'vehicle-status',
        },
        general_reports: {
            generate_report_history: 'generate-report-history',
            'poi-visit-report': 'poi-visit',
            'poi-stay-in':'general_report_generate_poi_stay_in_report',
            'movement':'general_report_generate_movement_report',
            'vehicle-events':'generate-report-vehicle-events'
        },
        vehicle_live_details: {
            vehicle_live_details: 'get-dashboard-data'
        }
    };

    public static GetApiUrl() {
        return ApiUrls.urls;
    }
}
